export const INIT_TABLE_FIELDS = 'INIT_TABLE_FIELDS';
export const REMOVE_TABLE = 'REMOVE_TABLE';
export const CHANGE_TABLE_FIELDS = 'CHANGE_TABLE_FIELDS';
export const UPDATE_POSITION_TABLE_FIELDS = 'UPDATE_POSITION_TABLE_FIELDS';
export const CHANGE_WIDTH_TABLE_FIELD = 'CHANGE_WIDTH_TABLE_FIELD';
export const CHANGE_SORT_TABLE = 'CHANGE_SORT_TABLE';
export const CHANGE_PAGE = 'CHANGE_PAGE';

export const FETCH_TABLE_PENDING = 'FETCH_TABLE_PENDING';
export const FETCH_TABLE_SUCCESS = 'FETCH_TABLE_SUCCESS';
export const FETCH_TABLE_ERROR = 'FETCH_TABLE_ERROR';

export const ADD_TABLE_DATA = 'ADD_TABLE_DATA';
export const PUT_TABLE_DATA = 'PUT_TABLE_DATA';
export const RESET_TABLE_DATA = 'RESET_TABLE_DATA';
export const REMOVE_TABLE_DATA_BY_ID = 'REMOVE_TABLE_DATA_BY_ID';
export const REPLACE_TABLE_DATA_BY_ID = 'REPLACE_TABLE_DATA_BY_ID';
